module.exports = __webpack_public_path__ + "static/media/about-truss-3.6a406722.png";